import { createFileRoute } from "@tanstack/react-router"
import News from "../../../components/News/NewsList"

export const Route = createFileRoute("/_layout/news/all-news")({
  component: News,
})
